import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/styles/main.sass'

Vue.use(Vuetify)

const theme = {
  primary: '#024589',
  secondary: '#d7e5f8',
  accent: '#BAC800',
  info: '#6d9ac9'
}

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },

  theme: {
    themes: {
      dark: theme,
      light: theme
    },
    options: {
      customProperties: true
    }
  }
})
